import webContextProvider from "../providers/webContextProvider";
import content from "app-content";

const appContentInitialiser = async () => {
  const { browseLanguage } = webContextProvider();
  Object.assign(
    content,
    (await import(`../../../i18n/${browseLanguage}.json`)).default
  );
};

export default appContentInitialiser;
